import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import React from "react";
import StarIcon from "../../icons/StarIcon";
import { formatMoney } from "../../../lib/formatMoney";
import { PaymentWalletButton } from "../../ButtonWalletPay";
import { format } from "date-fns";
import InvestmentCalculator from "../../InvestmentCalculator/InvestmentCalculator";

const StyledBox = styled(Box)(({ theme }) => ({
  padding: "30px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  marginBottom: "30px",
  [theme.breakpoints.down("sm")]: {
    padding: "15px",
  },
}));

const StyledInfoBox = styled(Box)(({ theme }) => ({
  padding: "5px 10px",
  borderRadius: "50px",
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.main,
  [theme.breakpoints.down("md")]: {
    borderRadius: "10px",
  },
}));

const StyledRowBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
}));

const StyledWrapperBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderBottom: "none",
  "&.br": {
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingRight: "10px",
  },
  [theme.breakpoints.down("md")]: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRight: "none",
    paddingBottom: "15px",
    "&.br": {
      borderRight: "none",
      paddingRight: "0px",
    },
  },
}));

const Details = ({ data }) => {
  return (
    <Stack direction="column" gap={{ xs: 2, md: 5 }} mb={3} mt={2}>
      <Stack direction="column" gap={2}>
        <Box mb={1}>
          <StarIcon />
        </Box>

        <Typography variant="h4" color="text.secondary">
          Detalles de compra
        </Typography>
        {/*  <Typography variant="subtitle1" color="text.primary">
          At Estatein, transparency is key. We want you to have a clear
          understanding of all costs associated with your property investment.
          Below, we break down the pricing for Seaside Serenity Villa to help
          you make an informed decision
        </Typography> */}
      </Stack>

      {/* <Stack
        direction="row"
        alignItems="center"
        border={`1px solid ${theme.palette.divider}`}
        bgcolor={theme.palette.background.main}
        padding={{ xs: "10px 20px", md: "20px 30px" }}
        borderRadius="10px"
      >
        <Typography
          variant="subtitle1"
          color="text.secondary"
          borderRight={`1px solid ${theme.palette.divider}`}
          pr={2}
          mr={2}
        >
          Note
        </Typography>
        <Typography variant="body1" color="text.primary">
          The figures provided above are estimates and may vary depending on the
          property, location, and individual circumstances.
        </Typography>
      </Stack> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={2} xl={2}>
          <Stack direction="column" gap={1}>
            <Typography variant="subtitle1" color="text.primary">
              {data.isNormal ? "Precios desde:" : "Precio:"}
            </Typography>
            <Typography variant="h5" color="text.secondary">
              {data.isNormal &&
                `${formatMoney({
                  amount: Number(data.price) || 0,
                  symbol: "$ ",
                  append: false,
                })}`}
              {data.saleStage.find((stage) => stage.status === "ACTIVE") &&
                formatMoney({
                  amount:
                    data.saleStage.find((stage) => stage.status === "ACTIVE")
                      .pricePerToken || 0,
                  symbol: "$ ",
                  append: false,
                })}{" "}
              USD
            </Typography>

            <Typography variant="h5" color="text.secondary">
              {data.isNormal &&
                `${formatMoney({
                  amount: Number(data.priceMxn) || 0,
                  symbol: "$ ",
                  append: false,
                })} MXN`}
            </Typography>
            <Typography variant="h5" color="text.secondary">
              {data.isNormal &&
                `${formatMoney({
                  amount: Number(data.price) || 0,
                  symbol: "$ ",
                  append: false,
                })} SOIL`}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={12} lg={10} xl={10}>
          <StyledBox>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              pb={3}
            >
              <Typography variant="h5" color="text.secondary">
                Detalles
              </Typography>
              {!data.isNormal && (
                <PaymentWalletButton
                  propertyId={data.id}
                  onPaymentSuccess={() => {
                    console.log("pago completado");
                  }}
                  onWindowClosed={() => {
                    console.log("ventana cerrada");
                  }}
                >
                  Comprar
                </PaymentWalletButton>
              )}
            </Stack>
            {/* Tabla tipo Excel */}
            {["IDO", "TOKEN"].includes(data.typeSell) && (
              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      {[
                        "Etapa",
                        "Estado",
                        "Tokens a vender",
                        "Tokens vendidos",
                        "Tokens disponibles",
                        "Avance",
                        "Precio",
                        "Inicio",
                        "Fin",
                        "ROI",
                      ].map((header) => (
                        <th
                          key={header}
                          style={{
                            textAlign: "center",

                            padding: "12px",
                            borderBottom: "1px solid #262626",
                            marginBottom: "20px",
                          }}
                        >
                          <Typography
                            variant="body1"
                            color="text.primary"
                            fontWeight="bold"
                          >
                            {header}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.saleStage.map((stage, index) => {
                      const color =
                        stage.status === "COMPLETED"
                          ? "text.primary"
                          : "text.secondary";
                      return (
                        <tr
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <td
                            style={{
                              paddingTop: "10px",
                              paddingBottom: "10px",
                            }}
                          >
                            <Typography variant="subtitle1" color={color}>
                              {stage.stageOrder}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {stage.status === "INACTIVE" && "Inactivo"}
                              {stage.status === "ACTIVE" && "Activo"}
                              {stage.status === "COMPLETED" && "Completado"}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {formatMoney({
                                amount: stage.totalTokens,
                                symbol: ` ${data.dataSell.symbol}`,
                              })}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {formatMoney({
                                amount: stage.totalSaleTokens,
                                symbol: ` ${data.dataSell.symbol}`,
                              })}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {formatMoney({
                                amount:
                                  stage.totalTokens - stage.totalSaleTokens,
                                symbol: ` ${data.dataSell.symbol}`,
                              })}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {stage.totalTokens > 0
                                ? `${(
                                    (stage.totalSaleTokens /
                                      stage.totalTokens) *
                                    100
                                  ).toFixed(2)} %`
                                : "-"}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {formatMoney({
                                amount: stage.pricePerToken,
                                symbol: "$ ",
                                append: false,
                              })}{" "}
                              USD
                            </Typography>
                          </td>

                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {!!stage.initAt
                                ? format(stage.initAt, "dd-MM-yyyy")
                                : "-"}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {" "}
                              {!!stage.endAt
                                ? format(stage.endAt, "dd-MM-yyyy")
                                : "-"}
                            </Typography>
                          </td>
                          <td>
                            <Typography variant="subtitle1" color={color}>
                              {formatMoney({
                                amount: stage.roi,
                                symbol: " %",
                              })}
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Box>
            )}
          </StyledBox>
          {["IDO", "TOKEN"].includes(data.typeSell) && (
            <InvestmentCalculator
              stages={data.saleStage.map((stage) => ({
                etapa: stage.stageOrder,
                precio: stage.pricePerToken,
                roi: stage.roi,
              }))}
            />
          )}
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Details;
